/**
* In Dashboard function is used to dispaly the Parents,Physician,Hospital module counts in UI
**/
import { Link } from 'react-router-dom';
import { useState,useEffect} from 'react';
import ApiService from './../../../services/ApiService';
// import constantVariables from './../../../dataset/constantVariables.json';
import { useTranslation } from 'react-i18next';

function Dashboard() {
	const { t } = useTranslation();
	//Intial state declaration
	const [data,setData]=useState({});
	
	//components initialize function and api handling
	useEffect(()=>{
	   (async()=>{
		     var response=await ApiService.getAdminDashboard();
			 if(response?.status===200)
				setData(response.data);	 
	   })();
   },[]);

  return (
   <main id="main" className="main">
		<div className="pagetitle">
		  <h1>{t('sidebar.dashboard')}</h1>
		</div>
		{/*Page Content Section*/}
		<section className="dashboard">
			<div className="row">
				{/* Parent Section */}
				<div className="col-xxl-4 col-md-6">
					<div className="card info-card">
						<div className="card-body">
							<div className="d-flex align-items-center">
								<div className="card-icon d-flex align-items-center justify-content-center">
									<i className="iconly-Light-People"></i>
								</div>
								<div className="card-text">									
									<h3>{t('sidebar.parents')}</h3>
									<h2>{data?.count?.parent_profiles}</h2>
								</div>
								<div className="card-btn ms-auto">	
									<Link to='/admin/parents'>{t('common.more')}</Link>
								</div>
							</div>
						</div>
					</div>
				</div>
				{/* End Parent Section */}
				
				{/* Physician Section */}
				<div className="col-xxl-4 col-md-6">
					<div className="card info-card">
						<div className="card-body">
							<div className="d-flex align-items-center">
								<div className="card-icon d-flex align-items-center justify-content-center">
									<i className="iconly-Light-TwoUsers"></i>
								</div>
								<div className="card-text">									
									<h3>{t('sidebar.physician')}</h3>
									<h2>{data?.count?.physician_profiles}</h2>
								</div>
								<div className="card-btn ms-auto">	
									<Link to='/admin/physician'>{t('common.more')}</Link>
								</div>
							</div>
						</div>
					</div>
				</div>
				{/* End Physician Section */}
				
				{/* Clinical Staff Section */}
				{/*<div className="col-xxl-4 col-md-6">
					<div className="card info-card">
						<div className="card-body">
							<div className="d-flex align-items-center">
								<div className="card-icon d-flex align-items-center justify-content-center">
									<i className="iconly-Light-AddUser"></i>
								</div>
								<div className="card-text">									
									<h3>{constantVariables.sidebar.clinicalStaff}</h3>
									<h2>97</h2>
								</div>
								<div className="card-btn ms-auto">	
									<Link to='/admin/clinical-staff'>{constantVariables.common.more}</Link>
								</div>
							</div>
						</div>
					</div>
				</div>*/}
				{/* End Clinical Staff Section */}

				{/* Hospital Section */}
				<div className="col-xxl-4 col-md-6">
					<div className="card info-card">
						<div className="card-body">
							<div className="d-flex align-items-center">
								<div className="card-icon d-flex align-items-center justify-content-center">
									<i className="iconly-Curved-Plus"></i>
								</div>
								<div className="card-text">									
									<h3>{t('sidebar.hospital')}</h3>
									<h2>{data?.count?.hospitals}</h2>
								</div>
								<div className="card-btn ms-auto">	
									<Link to='/admin/hospital'>{t('common.more')}</Link>
								</div>
							</div>
						</div>
					</div>
				</div>
				{/* End Hospital Section */}
			</div>
		</section>
		{/*End Page Content Section*/}
	</main>
  );
}

export default Dashboard;
